import React, { useState } from 'react';
import { Box } from '@mui/material';
import NavigationBar from './NavigationBar';
import SmartEventList from '../SmartEventList/SmartEventList';
import ReviewerPanel from '../Reviewers/ReviewerPanel';

const RightSidebar = ({
  childClicked,
  onLocationClick,
  type,
  setType,
  language,
  searchQuery, // NEW: Search query to pass to SmartEventList
  startDate,   // NEW: Start date for filtering
  endDate,     // NEW: End date for filtering
  source,              // NEW: Which collections to search
  excludeCategories,   // NEW: Categories to exclude
  categoryFilter,      // NEW: Category filter from tab config
  onActiveIndexChange,
  onItemsChange, // NEW: Callback to receive items from SmartEventList
  onMapSyncNeeded, // NEW: Callback for map synchronization
  userLocation,
  feedLat,
  feedLng,
  feedRadiusKm,
  onTTSToggle,
  isTTSPlaying,
  isTTSDisabled,
  audioOutputDevices,
  selectedOutputDeviceId,
  onOutputDeviceChange,
  onTTSRestart,
  selectedCreator,
  setSelectedCreator,
  creatorProfile,
  onReviewerSelect,
  onCreatorClick,
}) => {
  // Local state to keep track of items count
  const [displayedItems, setDisplayedItems] = useState([]);

  const handleInternalItemsChange = (items) => {
    setDisplayedItems(items);
    if (onItemsChange) onItemsChange(items);
  };

  // ผู้รีวิว tab renders its own panel (reviewer directory + that reviewer's items)
  const isReviewerTab = type === 'Reviewers';

  return (
    <Box sx={{
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#ffffff',
      width: '100%'
    }}>
      {/* Navigation Bar */}
      <Box sx={{ flexShrink: 0 }}>
        <NavigationBar
          type={type}
          setType={setType}
          language={language}
          onTTSToggle={onTTSToggle}
          isTTSPlaying={isTTSPlaying}
          isTTSDisabled={isTTSDisabled}
          audioOutputDevices={audioOutputDevices}
          selectedOutputDeviceId={selectedOutputDeviceId}
          onOutputDeviceChange={onOutputDeviceChange}
          onTTSRestart={onTTSRestart}
        />
      </Box>

      {/* Reviewer directory tab — its own panel, not the geo feed */}
      {isReviewerTab ? (
        <Box sx={{ flexGrow: 1, overflow: 'hidden', width: '100%', minHeight: 0 }}>
          <ReviewerPanel
            selectedReviewer={selectedCreator}
            onSelectReviewer={onReviewerSelect || setSelectedCreator}
            onClearReviewer={() => setSelectedCreator(null)}
            profile={creatorProfile}
            language={language}
            layout="vertical"
            childClicked={childClicked}
            onLocationClick={onLocationClick}
            onActiveIndexChange={onActiveIndexChange}
            onItemsChange={handleInternalItemsChange}
          />
        </Box>
      ) : (
      /* Event List - takes remaining space */
      <Box sx={{
        flexGrow: 1,
        overflow: 'hidden',
        padding: 0,
        width: '100%'
      }}>
        <SmartEventList
          key={`v-${Array.isArray(source) ? source.join('-') : source}-${Array.isArray(excludeCategories) ? excludeCategories.join('-') : ''}`}
          layout="vertical"
          context="explore"
          feedMode={true} // CRITICAL: Enable feed batching system
          enabled={feedLat !== null && feedLat !== undefined}
          userLocation={userLocation}
          lat={feedLat}
          lng={feedLng}
          radiusKm={feedRadiusKm ?? undefined}
          searchQuery={searchQuery} // NEW: Pass search query to trigger list refresh
          category={categoryFilter || undefined} // NEW: Use tab's categoryFilter
          source={source}                   // NEW: Which collections to search
          excludeCategories={excludeCategories} // NEW: Categories to exclude
          startDate={startDate} // NEW: Pass start date for filtering
          endDate={endDate}     // NEW: Pass end date for filtering
          childClicked={childClicked}
          onLocationClick={onLocationClick}
          onActiveIndexChange={onActiveIndexChange}
          onItemsChange={handleInternalItemsChange} // Use internal wrapper to get item count
          onMapSyncNeeded={onMapSyncNeeded} // NEW: Pass callback through
          language={language}
          onCreatorClick={onCreatorClick} // Reviewer name on a card → ผู้รีวิว tab
        />
      </Box>
      )}
    </Box>
  );
};

export default RightSidebar;